// extracted by mini-css-extract-plugin
export default {"container":"PortfolioContent_container__xXay+","mainRow":"PortfolioContent_mainRow__9GSdW","ul":"PortfolioContent_ul__0zh0D"};